module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingStatistik.76e54637.png";